import React, { useRef, useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Edit, Delete, Check, AccessTime } from "@mui/icons-material";
import { CashIcon, CreateIcon, EyeIcon, RequestBuyerIdIcon } from "assets";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import WhatsApp from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import { Link } from "react-router-dom";
import Colors from "assets/Style/Colors";
import { useAuth } from "context/UseContext";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { LuDownload } from "react-icons/lu";
import moment from "moment";
import { FiDownload } from "react-icons/fi";

const DropdownMenu = ({
  creditNoteValidation,
  item,
  detail,
  permissions,
  navigate,
  setOpenDelete,
  setShippingId,
  ErrorToaster,
  isOpen,
  onToggle,
  onClick1,
  onClick2,
  excelDownload,
  onAllocateClick,
  onBuyerIdAllocation,
  onMessageClick,
  id,
  isDelete,
  onDeleteClick,
  isEdit,
  viewInvoice,
  invoice,
  deleteInvoice,
  whatsAppClick,
  emailClick,
  isForward,
  onEdit,
  suplierListingView,
  suplierListingEdit,
  suplierListingCompleteProfile,
  BillEdit,
  BillDelete,
  BillView,
  BillApprove,
  // onEditVehicleBooking,
  onClickUpdateSalesInfo,
  vccIssue,
  depositView,
  voucher,
  voucherView,
  voucherEdit,
  paymentVoucherEdit,
  receiptVoucherEdit,
  EditReconcile,
  DeleteReconcile,
  reverseVoucher,
  iftv,
  client,
  isValid,
  isGpDelete,
  addCustomVat,
  customVat,
  handleCharge,
  handleReverse,
  showVendorData,
  isRole,
  isBuyerId,
  vendorApplyFund,
  vendorViewDetail,
  onViewDetail,
  vendorDeleteIcon,
  isAdmin,
  vendorEdit,
  onClickReverseVCC,
  onClickReverseEP,
  onClickCustomCharge,
  onClickDeleteVCC,
  onClickDeleteIssueMobaya,
  onClickReverseIssueMobaya,
  onClickNotesIssueMobaya,
  receiveCec,
  salesCertificate,
  importCustomer,
  route,
  vehicleTT,
  vendorPlan,
  reverseEP,
  deleteReferri,
  onClickgatePassView,
  onClickgatePassDelete,
  onClickDeleteGP,
  onClickEditPrepaid,
  onClickDeletePrepaid,
  onClickEditSpecialDiscount,
  onClickDeleteSpecialDiscount,
  onClickViewSpecialDiscount,
  deleteClientCosting,
  viewClientCosting,
  clientCostingNotes,
  clientCostingNotesS,
  clientCostingNotesC,
  onClickEditExportVendor,
  onClickViewExportVendor,
  onClickViewDamageView,
  onClickDeleteDamageView,
  onClickDeleteExportVendor,
  onClickDeletepaidunpaidV2,
  onClickDeletepaidunpaidV1,
  onClickAssignPermission,
  onClickReverseExitPaper,
  containerListBolDocument,
  containerListtelaxDocument,
  onClickEditDamages,
  onClickDeleteDamages,
  onClickViewDamages,
  onClickDamagesNotes,
  onClickUpdateDamagesClaim,
  onClickViewDamageClaimNotes,
  onClickEditDamageClaimNotes,
  paidBillsView,
  paidBillsDelete,
  pdf = true,
  v2 = true,
  uploadVendorInvoiceEdit,
  downloadVendorInvoice,
  is_consignment,
  consignmentView,
  whatsAppItem,
  disableDeleteInvoice = false,
  dockReceiptView,
  is_dock_receipt,
}) => {
  const clearance =
    parseFloat(item?.vendor_costing?.clearance_vendor_total) || 0;
  const shipping = parseFloat(item?.vendor_costing?.shipping_vendor_total) || 0;
  const towing = parseFloat(item?.vendor_costing?.towing_vendor_total) || 0;

  const canDelete =
    !item?.client_costings && clearance === 0 && shipping === 0 && towing === 0;

  const dropdownRef = useRef(null);
  const { user } = useAuth();
  // Close dropdown when clicking outside
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);

  const date = moment(item?.vcc_expiry_date).format("DD-MM-YYYY");
  const targetDate = moment(date, "DD-MM-YYYY");
  const gatePassDetails = item?.gate_pass?.details ?? [];
  const hasUnpaid = gatePassDetails.some((d) => d?.is_paid === false);
  const hasPaid = gatePassDetails.some((d) => d?.is_paid === true);
  let daysRemaining = targetDate.diff(
    item?.exit_paper_received_at || moment(),
    "days",
  );
  if (daysRemaining < 0) {
    daysRemaining = 0;
  }
  const isPaid = item?.pmt_status === "paid";
  const isPaymentDoneForInvoice =
    Number(item?.paid ?? item?.invoice?.paid ?? 0) > 0;
  const isContainerAddedForInvoice = Boolean(
    item?.booking?.vehicle?.shipping_id ||
    item?.booking?.vehicle?.container_no ||
    item?.booking?.shipping_id ||
    item?.booking?.container_no ||
    item?.booking?.vehicle?.client_costings,
  );
  const isInvoiceDeleteBlocked =
    (isContainerAddedForInvoice && isPaymentDoneForInvoice) ||
    disableDeleteInvoice;
  const latestDetail = [...(item?.gate_pass?.details || [])]?.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  )[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onToggle(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onToggle]);
  const closeMenu = () => onToggle(false);
  return (
    <div ref={dropdownRef} className="dropdown-container">
      <div onClick={() => onToggle(!isOpen)} className="dropdown-button">
        <MoreVertIcon />
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          {/* Vendor Plans Options*/}
          {vendorPlan && (
            <>
              {(permissions?.edit_plan || user?.user_type == "A") && (
                <div
                  onClick={() => {
                    onEdit();
                    closeMenu();
                  }}
                  className="dropdown-item"
                >
                  <IconButton sx={{}} className="icon">
                    <Edit
                      sx={{
                        color: Colors.black,
                        height: "20px !important",
                      }}
                    />
                  </IconButton>
                  <span>Edit </span>
                </div>
              )}

              {(permissions?.delete_plan || user?.user_type == "A") && (
                <div
                  onClick={() => {
                    if (!item?.vendor_costing_data) {
                      onDeleteClick();
                    }
                    closeMenu();
                    // setConfirmationDialog(true);
                    // setBuyerId(item.id);
                  }}
                  className="dropdown-item"
                >
                  <IconButton
                    sx={{
                      color: item?.vendor_costing_data ? Colors.grey : "",
                      // bgcolor: Colors.danger,
                      // "&:hover": {
                      //   bgcolor: Colors.danger,
                      // },
                    }}
                    className="icon"
                  >
                    <Delete
                      sx={{
                        color: item?.vendor_costing_data
                          ? Colors.grey
                          : Colors.danger,
                        height: "20px !important",
                      }}
                    />
                  </IconButton>
                  <span>Delete</span>
                </div>
              )}
              {pdf && (
                <div
                  onClick={() => {
                    onClick2();
                    closeMenu();
                  }}
                  className="dropdown-item"
                >
                  <IconButton sx={{}} className="icon">
                    <LuDownload />
                  </IconButton>
                  <span>PDF</span>
                </div>
              )}
              <div
                onClick={() => {
                  excelDownload();
                  closeMenu();
                }}
                className="dropdown-item"
              >
                <IconButton sx={{}} className="icon">
                  <LuDownload />
                </IconButton>
                <span>Excel</span>
              </div>
            </>
          )}

          {/* Container List*/}

          {containerListBolDocument && (
            <div
              onClick={() => {
                containerListBolDocument();
              }}
              className="dropdown-item"
            >
              <Box
                sx={{
                  // bgcolor:
                  //   item?.bl
                  //     ? Colors.primary
                  //     : Colors.grey,
                  // "&:hover": {
                  //   bgcolor:
                  //    item?.bl
                  //       ? Colors.primary
                  //       : Colors.grey,
                  // },
                  cursor: item?.bl ? "pointer" : "not-allowed",
                  p: "8px",
                }}
                className="icon"
              >
                <FiDownload
                  sx={{
                    height: "16px !important",
                  }}
                  color={Colors.black}
                />
              </Box>
              <span>BL Doc</span>
            </div>
          )}

          {containerListtelaxDocument && (
            <div
              onClick={() => {
                containerListtelaxDocument();
              }}
              className="dropdown-item"
            >
              <Box
                sx={{
                  // bgcolor:
                  //   item?.bl
                  //     ? Colors.primary
                  //     : Colors.grey,
                  // "&:hover": {
                  //   bgcolor:
                  //    item?.bl
                  //       ? Colors.primary
                  //       : Colors.grey,
                  // },
                  cursor: item?.auction_invoice ? "pointer" : "not-allowed",
                  p: "8px",
                }}
                className="icon"
              >
                <FiDownload
                  sx={{
                    height: "16px !important",
                  }}
                  color={Colors.black}
                />
              </Box>
              <span>R.Telax Doc</span>
            </div>
          )}

          {/* Add Custom And Vat Options*/}
          {customVat && (
            <>
              {(item?.arrived_port_date && item?.vcc?.id) ||
              item?.vcc?.custom_income_aed > 0 ||
              item?.vcc?.cv_charged_directly ? (
                <Tooltip
                  title={
                    item?.vcc?.vcc_purpose
                      ? "VCC Purpose already added so Can't Update"
                      : item?.vcc?.cv_charged_directly
                        ? "Custom & VAT already charged"
                        : ""
                  }
                >
                  <Box
                    sx={{
                      cursor: item?.vcc?.vcc_purpose
                        ? "not-allowed"
                        : "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                    className="dropdown-item"
                    onClick={() => {
                      addCustomVat();
                      closeMenu();
                    }}
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          item?.vcc?.vcc_purpose ||
                          item?.vcc?.cv_charged_directly
                            ? Colors.grey
                            : Colors.blackShade,
                        "&:hover": {
                          bgcolor:
                            item?.vcc?.vcc_purpose ||
                            item?.vcc?.cv_charged_directly
                              ? Colors.grey
                              : Colors.blackShade,
                        },
                        cursor:
                          item?.vcc?.vcc_purpose ||
                          item?.vcc?.cv_charged_directly
                            ? "not-allowed"
                            : "pointer",
                      }}
                      className="icon"
                      disabled={
                        !!(
                          item?.vcc?.vcc_purpose ||
                          item?.vcc?.cv_charged_directly
                        )
                      }
                    >
                      <Edit
                        sx={{
                          color:
                            item?.vcc?.vcc_purpose ||
                            item?.vcc?.cv_charged_directly
                              ? Colors.grey
                              : Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color:
                          item?.vcc?.vcc_purpose ||
                          item?.vcc?.cv_charged_directly
                            ? Colors.grey
                            : "inherit",
                      }}
                    >
                      Add Custom & VAT
                    </Typography>
                  </Box>
                </Tooltip>
              ) : null}
              {(permissions["charge_C&V"] || isAdmin) && (
                <Tooltip
                  title={
                    !item?.vcc?.custom_charges_aed
                      ? "Custom charges not added"
                      : item?.vcc?.cv_charged_directly
                        ? "Custom & VAT already charged"
                        : item?.vcc?.vcc_purpose
                          ? "VCC Purpose already added so Can't Update"
                          : ""
                  }
                  arrow
                >
                  <div className="dropdown-item">
                    <Box
                      component="div"
                      className="pdf-hide"
                      style={
                        !item?.vcc?.custom_charges_aed ||
                        item?.vcc?.cv_charged_directly ||
                        item?.vcc?.vcc_purpose
                          ? { opacity: 0.5, pointerEvents: "none" } // Disable button style
                          : {}
                      }
                      onClick={() => {
                        if (
                          item?.vcc?.custom_charges_aed &&
                          !item?.vcc?.cv_charged_directly &&
                          !item?.vcc?.vcc_purpose
                        ) {
                          handleCharge();
                          closeMenu();
                        }
                      }}
                    >
                      <IconButton
                        sx={{
                          bgcolor:
                            !item?.vcc?.custom_charges_aed ||
                            item?.vcc?.cv_charged_directly
                              ? Colors.grey // Disabled state color
                              : Colors.primary, // Enabled state color
                          "&:hover": {
                            bgcolor:
                              !item?.vcc?.custom_charges_aed ||
                              item?.vcc?.cv_charged_directly ||
                              item?.vcc?.vcc_purpose
                                ? Colors.grey
                                : Colors.primary,
                          },
                          p: "8px",
                        }}
                      >
                        <Edit
                          sx={{
                            color: Colors.white,
                            height: "16px !important",
                          }}
                        />
                      </IconButton>
                      <Typography variant="body2">
                        Charge Custom & VAT
                      </Typography>
                    </Box>
                  </div>
                </Tooltip>
              )}

              {(permissions["reverse_C&V"] || isAdmin) && (
                <Tooltip
                  title={
                    !item?.vcc?.cv_charged_directly
                      ? "Custom & VAT not charged"
                      : item?.vcc?.vcc_purpose !== null
                        ? "VCC Purpose already added so Can't Reversed"
                        : ""
                  }
                  arrow
                >
                  <div className="dropdown-item">
                    <Box
                      component="div"
                      className="pdf-hide"
                      style={
                        !item?.vcc?.cv_charged_directly ||
                        item?.vcc?.vcc_purpose !== null
                          ? { opacity: 0.5, pointerEvents: "none" }
                          : {}
                      }
                      onClick={() => {
                        if (item?.vcc?.cv_charged_directly) {
                          handleReverse();
                          closeMenu();
                        }
                      }}
                    >
                      <IconButton
                        sx={{
                          bgcolor:
                            !item?.vcc?.cv_charged_directly ||
                            item?.vcc?.vcc_purpose !== null
                              ? Colors.grey
                              : Colors.primary,
                          "&:hover": {
                            bgcolor:
                              !item?.vcc?.cv_charged_directly ||
                              item?.vcc?.vcc_purpose !== null
                                ? Colors.grey
                                : Colors.primary,
                          },
                          p: "8px",
                        }}
                        // disabled={!item?.vcc?.cv_charged_directly}
                      >
                        <Edit
                          sx={{
                            color: Colors.white,
                            height: "16px !important",
                          }}
                        />
                      </IconButton>
                      <Typography variant="body2">
                        Reverse Custom & VAT
                      </Typography>
                    </Box>
                  </div>
                </Tooltip>
              )}
              {(permissions?.["delete-C&V"] || isAdmin) && (
                <Tooltip
                  title={
                    item?.vcc?.vcc_purpose
                      ? "VCC Purpose already added so Can't Delete"
                      : item?.vcc?.cv_charged_directly
                        ? "Custom & VAT already charged"
                        : ""
                  }
                  arrow
                >
                  <div
                    onClick={() => {
                      if (
                        item?.vcc?.vcc_purpose == null ||
                        !item?.vcc?.cv_charged_directly ||
                        !item?.vcc?.vcc_purpose
                      ) {
                        onDeleteClick();
                        closeMenu();
                      }
                      // setConfirmationDialog(true);
                      // setBuyerId(item.id);
                    }}
                    className="dropdown-item"
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          item?.vcc?.vcc_purpose ||
                          item?.vcc?.cv_charged_directly
                            ? Colors.grey
                            : Colors.danger,
                        "&:hover": {
                          bgcolor:
                            item?.vcc?.vcc_purpose ||
                            item?.vcc?.cv_charged_directly
                              ? Colors.grey
                              : Colors.danger,
                        },
                        cursor: item?.vcc?.vcc_purpose
                          ? "not-allowed"
                          : "pointer",
                        p: "8px",
                      }}
                      className="icon"
                    >
                      <Delete
                        sx={{
                          color: Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <span>Delete Custom & VAT</span>
                  </div>
                </Tooltip>
              )}
            </>
          )}
          {/* Update buyer id */}
          {permissions?.update && !isEdit && !importCustomer && (
            <div
              onClick={() => {
                onClick1(id);
                closeMenu();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.bluishCyan,
                  "&:hover": {
                    bgcolor: Colors.bluishCyan,
                  },
                }}
                className="icon"
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <span>Edit </span>
            </div>
          )}
          {/* Edit Import Customer */}
          {permissions &&
            (permissions["edit_import_customer"] || user?.user_type == "A") &&
            importCustomer && (
              <div
                onClick={() => {
                  onClick1(id);
                  closeMenu();
                }}
                className="dropdown-item"
              >
                <IconButton
                  sx={{
                    bgcolor:
                      user?.role_id === 1000 ||
                      item?.rm_id === user?.id ||
                      user?.id === 56197 ||
                      user?.id === 50917 ||
                      user?.id === 56743 ||
                      item?.rm_id === 50926 ||
                      item?.rm_id === 56212 ||
                      item?.rm_id === 56642 ||
                      item?.rm_id === 50925
                        ? Colors.bluishCyan
                        : Colors.bluishCyan,
                    "&:hover": {
                      bgcolor:
                        user?.role_id === 1000 ||
                        item?.rm_id === user?.id ||
                        user?.id === 56197 ||
                        user?.id === 50917 ||
                        user?.id === 56743 ||
                        item?.rm_id === 50926 ||
                        item?.rm_id === 56212 ||
                        item?.rm_id === 56642 ||
                        item?.rm_id === 50925
                          ? Colors.bluishCyan
                          : Colors.bluishCyan,
                    },
                  }}
                  className="icon"
                  disabled={
                    user?.role_id !== 1000 ||
                    item?.rm_id !== user?.id ||
                    user?.id !== 56197 ||
                    user?.id !== 50917 ||
                    user?.id !== 56743 ||
                    item?.rm_id !== 50926 ||
                    item?.rm_id !== 56212 ||
                    item?.rm_id !== 50928 ||
                    item?.rm_id !== 56642 ||
                    item?.rm_id !== 50925
                  }
                >
                  <Edit
                    sx={{
                      color:
                        user?.role_id === 1000 ||
                        item?.rm_id === user?.id ||
                        user?.id === 56197 ||
                        user?.id === 50917 ||
                        user?.id === 56743 ||
                        item?.rm_id === 50926 ||
                        item?.rm_id === 56212 ||
                        item?.rm_id === 56642 ||
                        item?.rm_id === 50925
                          ? Colors.black
                          : Colors.grey,

                      // color: Colors.white,
                      height: "16px !important",
                    }}
                  />
                </IconButton>
                <span>Edit</span>
              </div>
            )}
          {/*  Permissions role permission */}

          {permissions?.permission && (
            <div
              onClick={() =>
                navigate(`/permission/${item?.id}`, { state: item })
              }
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.blackShade,
                  "&:hover": {
                    bgcolor: Colors.blackShade,
                  },
                }}
                className="icon"
              >
                <RequestBuyerIdIcon />
              </IconButton>
              <Typography variant="body2">Permission</Typography>
            </div>
          )}
          {/* Delete buyer id and Delete role permission */}
          {permissions?.delete && viewInvoice !== "invoice" && (
            <div
              onClick={() => {
                onDeleteClick();
                // setConfirmationDialog(true);
                // setBuyerId(item.id);
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.danger,
                  "&:hover": {
                    bgcolor: Colors.danger,
                  },
                }}
                className="icon"
              >
                <Delete
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <span>Delete</span>
            </div>
          )}
          {/* View Invoice Option */}
          {invoice && (
            <Link
              to={`/${viewInvoice}/${id}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 16px",
                cursor: "pointer",
                color: "#000",
                textDecoration: "none",
                backgroundColor: isHovered ? "#eff9e8" : "transparent",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <VisibilityIcon style={{ marginRight: "5px" }} />
              <span>View</span>
            </Link>
          )}
          {/* {invoice &&
                        <div
                            onClick={() => {
                                window.open(viewInvoice(id))
                                closeMenu();
                            }}
                            className="dropdown-item"
                        >
                            <VisibilityIcon className='icon' />
                            <span>View</span>
                        </div>
                    } */}

          {/* Vehicle TT delete and Edit button */}
          {vehicleTT && (
            <>
              <Link
                to={`/buyer-tt-detail/${id}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px 16px",
                  cursor: "pointer",
                  textDecoration: "none",
                  color: "#000",
                  backgroundColor: isHovered2 ? "#eff9e8" : "transparent",
                }}
                onMouseEnter={() => setIsHovered2(true)}
                onMouseLeave={() => setIsHovered2(false)}
              >
                <VisibilityIcon style={{ marginRight: "5px" }} />
                <span>VBI. Plan</span>
              </Link>
              <div
                onClick={() => {
                  if (item?.status == "draft") {
                    onClick1(id);
                  }
                  closeMenu();
                }}
                className="dropdown-item"
                style={{
                  cursor: item?.status == "draft" ? "pointer" : "not-allowed",
                  opacity: item?.status == "draft" ? 1 : 0.6,
                }}
              >
                <IconButton
                  sx={{
                    bgcolor: Colors.bluishCyan,
                    "&:hover": {
                      bgcolor: Colors.bluishCyan,
                    },
                  }}
                  className="icon"
                >
                  <Edit
                    sx={{
                      color: Colors.white,
                      height: "16px !important",
                    }}
                  />
                </IconButton>
                <span>Edit </span>
              </div>
            </>
          )}
          {(permissions?.delete_vehicle_tt || user?.user_type == "A") &&
            vehicleTT && (
              <div
                onClick={() => {
                  deleteInvoice(item?.id);
                  closeMenu();
                }}
                className="dropdown-item"
                style={{
                  cursor: "pointer",
                }}
              >
                <Delete
                  sx={{
                    color: Colors.danger,
                  }}
                  className="icon"
                />
                <span>Delete</span>
              </div>
            )}

          {/* Delete Vcc Option */}
          {(permissions?.["delete-vcc"] || (isAdmin && vccIssue)) && (
            <Tooltip
              title={
                item?.exit_paper_received ||
                item?.makasa_received ||
                item?.vehicle?.mobaya_reference
                  ? "VCC Document Issued/Received"
                  : ""
              }
            >
              <div
                onClick={(e) => {
                  if (
                    item?.exit_paper_received ||
                    item?.makasa_received ||
                    item?.vehicle?.mobaya_reference
                  ) {
                    e.stopPropagation();
                    return;
                  }
                  deleteInvoice(
                    item?.id,
                    item?.booking_id,
                    item?.booking?.customer_id,
                  );
                  closeMenu();
                }}
                className="dropdown-item"
                style={{
                  cursor:
                    item?.exit_paper_received ||
                    item?.makasa_received ||
                    item?.vehicle?.mobaya_reference
                      ? "not-allowed"
                      : "pointer",
                  opacity:
                    item?.exit_paper_received ||
                    item?.makasa_received ||
                    item?.vehicle?.mobaya_reference
                      ? 0.6
                      : 1,
                }}
              >
                <Delete
                  sx={{
                    color:
                      item?.exit_paper_received ||
                      item?.makasa_received ||
                      item?.vehicle?.mobaya_reference
                        ? Colors.grey
                        : Colors.danger,
                  }}
                  className="icon"
                />
                <span>Delete</span>
              </div>
            </Tooltip>
          )}

          {/* Delete depositView Option */}

          {depositView && (
            <Box
              component={"div"}
              className="pdf-hide dropdown-item"
              sx={{ gap: "16px !important" }}
            >
              <Box onClick={depositView}>
                <IconButton
                  sx={{
                    bgcolor: Colors.primary,
                    "&:hover": { bgcolor: Colors.primary },
                  }}
                >
                  <EyeIcon />
                </IconButton>
                <Typography variant="body2">View</Typography>
              </Box>
            </Box>
          )}
          {depositView && (permissions || isAdmin) && (
            <Tooltip
              title={
                item?.vcc?.is_refunded
                  ? "Refunded deposit can't be deleted."
                  : ""
              }
            >
              <div
                onClick={() => {
                  if (item?.vcc?.is_refunded) {
                    return;
                  }
                  deleteInvoice(item?.vcc?.id);
                  closeMenu();
                }}
                className="dropdown-item"
                style={{
                  cursor: item?.vcc?.is_refunded ? "not-allowed" : "pointer",
                }}
              >
                <Delete
                  sx={{
                    color: item?.vcc?.is_refunded ? Colors.grey : Colors.danger,
                  }}
                  className="icon"
                />
                <span>Delete</span>
              </div>
            </Tooltip>
          )}

          {onClickDeleteGP && (
            <Tooltip
              title={
                item?.is_paid === false
                  ? "Gate pass for this vehicle has not paid"
                  : ""
              }
            >
              <Box component="div" className="dropdown-item">
                <IconButton
                  disabled={item?.is_paid === false}
                  sx={{
                    bgcolor:
                      item?.is_paid === false ? Colors.grey : Colors.danger,
                    "&:hover": {
                      bgcolor:
                        item?.is_paid === false ? Colors.grey : Colors.danger,
                    },
                  }}
                  className="icon"
                  onClick={() => {
                    onClickDeleteGP();
                  }}
                >
                  <Delete
                    sx={{ color: Colors.white, height: "16px !important" }}
                  />
                </IconButton>
              </Box>
            </Tooltip>

            //   <Box
            //     component={"div"}
            //     onClick={onClickDeleteGP}
            //     className="dropdown-item"
            //   >
            //     <IconButton
            //       sx={{
            //         bgcolor: Colors.danger,
            //         "&:hover": {
            //           bgcolor: Colors.danger,
            //         },
            //       }}
            //     >
            //       <Delete
            //         sx={{
            //           color: Colors.white,
            //           height: "16px !important",
            //         }}
            //       />
            //     </IconButton>

            //   </Box>
            //
          )}

          {onClickEditPrepaid && (
            <Box
              component="div"
              onClick={() => {
                onClickEditPrepaid();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
                className="icon"
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
            </Box>
          )}

          {onClickDeletePrepaid && (
            <Box component="div" className="dropdown-item">
              <IconButton
                className="icon"
                sx={{
                  bgcolor: Colors.danger,
                }}
                onClick={() => {
                  onClickDeletePrepaid();
                }}
              >
                <Delete
                  sx={{ color: Colors.white, height: "16px !important" }}
                />
              </IconButton>
            </Box>
          )}

          {/*special discount*/}
          {onClickViewSpecialDiscount && (
            <Box component="div" className="dropdown-item">
              <IconButton
                className="icon"
                sx={{
                  bgcolor: Colors.danger,
                }}
                onClick={() => {
                  onClickViewSpecialDiscount();
                }}
              >
                <EyeIcon
                  sx={{ color: Colors.white, height: "16px !important" }}
                />
              </IconButton>
            </Box>
          )}

          {onClickEditSpecialDiscount && (
            <Box
              component="div"
              onClick={() => {
                onClickEditSpecialDiscount();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
                className="icon"
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
            </Box>
          )}

          {onClickDeleteSpecialDiscount && (
            <Box component="div" className="dropdown-item">
              <IconButton
                className="icon"
                sx={{
                  bgcolor: Colors.danger,
                }}
                onClick={() => {
                  onClickDeleteSpecialDiscount();
                }}
              >
                <Delete
                  sx={{ color: Colors.white, height: "16px !important" }}
                />
              </IconButton>
            </Box>
          )}

          {/**Export Vendor */}

          {onClickEditExportVendor && (
            <Box
              component="div"
              onClick={() => {
                onClickEditExportVendor();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
                className="icon"
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
            </Box>
          )}

          {onClickViewExportVendor && (
            <Box component="div" className="dropdown-item">
              <IconButton
                className="icon"
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
                onClick={() => {
                  onClickViewExportVendor();
                }}
              >
                <EyeIcon
                  sx={{ color: Colors.white, height: "16px !important" }}
                />
              </IconButton>
            </Box>
          )}
          {onClickDeleteExportVendor && (
            <Box component="div" className="dropdown-item">
              <IconButton
                className="icon"
                sx={{
                  bgcolor: Colors.danger,
                  ":hover": {
                    bgcolor: Colors.danger,
                  },
                }}
                onClick={() => {
                  onClickDeleteExportVendor();
                }}
              >
                <Delete
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
            </Box>
          )}

          {/**Damage View */}

          {onClickViewDamageView && (
            <Box
              component="div"
              className="dropdown-item"
              onClick={() => {
                onClickViewDamageView();
              }}
            >
              <IconButton
                className="icon"
                sx={{
                  bgcolor: Colors.primary,
                }}
              >
                <EyeIcon
                  sx={{ color: Colors.white, height: "16px !important" }}
                />
              </IconButton>
              <Typography variant="body2" color={Colors.black}>
                View & Receive Damages
              </Typography>
            </Box>
          )}

          {onClickDeleteDamageView && (
            <Box
              sx={{ display: "flex", justifyContent: "start !important" }}
              component="div"
              onClick={() => {
                onClickDeleteDamageView();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.danger,
                  "&:hover": {
                    bgcolor: Colors.danger,
                  },
                }}
                className="icon"
              >
                <Delete
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <Typography variant="body2" color={Colors.black}>
                Delete
              </Typography>
            </Box>
          )}

          {/* Client Costing */}

          {/* {onClickEditPrepaid && (
            <Box
              onClick={() => {
                onClickEditPrepaid();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
            </Box>
          )} */}

          {/* Create Gate Pass Button */}

          {viewClientCosting && (
            <Box
              onClick={() => {
                viewClientCosting(item);
              }}
              className="dropdown-item"
            >
              <IconButton
                // sx={{
                //   bgcolor: Colors.primary,
                //   "&:hover": {
                //     bgcolor: Colors.primary,
                //   },
                // }}
                disabled={item?.total_v2 === "0.000"}
                sx={{
                  bgcolor:
                    item?.total_v2 === "0.000" ? Colors.grey : Colors.danger,
                  "&:hover": {
                    bgcolor:
                      item?.total_v2 === "0.000" ? Colors.grey : Colors.danger,
                  },
                }}
              >
                <EyeIcon />
              </IconButton>
              <Typography variant="body2" color={Colors.black}>
                View
              </Typography>
            </Box>
          )}

          {clientCostingNotes && (
            <Box
              onClick={() => {
                clientCostingNotes(item);
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <Typography variant="body2" color={Colors.black}>
                V Notes
              </Typography>
            </Box>
          )}
          {clientCostingNotesS && (
            <Box
              onClick={() => {
                clientCostingNotesS(item);
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />{" "}
              </IconButton>
              <Typography variant="body2" color={Colors.black}>
                S Notes
              </Typography>
            </Box>
          )}
          {clientCostingNotesC && (
            <Box
              onClick={() => {
                clientCostingNotesC(item);
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />{" "}
              </IconButton>
              <Typography variant="body2" color={Colors.black}>
                C Notes
              </Typography>
            </Box>
          )}

          {deleteClientCosting && (
            <Tooltip
              title={
                !(
                  (item?.vehicle?.vcc?.custom_charges_aed == null ||
                    parseFloat(item?.vehicle?.vcc?.custom_charges_aed) === 0) &&
                  (item?.vehicle?.vcc?.vat_charges_aed == null ||
                    parseFloat(item?.vehicle?.vcc?.vat_charges_aed) === 0) &&
                  parseFloat(item?.invoice?.paid) === 0
                )
                  ? "Custom & VAT or Shipping already paid"
                  : ""
              }
            >
              <Box
                component="div"
                className="dropdown-item"
                onClick={() => {
                  deleteClientCosting();
                }}
              >
                <IconButton
                  className="icon"
                  // sx={{
                  //   bgcolor: Colors.danger,
                  // }}
                  sx={{
                    bgcolor:
                      (item?.vehicle?.vcc?.custom_charges_aed == null ||
                        parseFloat(item?.vehicle?.vcc?.custom_charges_aed) ===
                          0) &&
                      (item?.vehicle?.vcc?.vat_charges_aed == null ||
                        parseFloat(item?.vehicle?.vcc?.vat_charges_aed) ===
                          0) &&
                      parseFloat(item?.invoice?.paid) === 0
                        ? Colors.danger
                        : Colors.grey,
                  }}
                  disabled={
                    !(
                      (item?.vehicle?.vcc?.custom_charges_aed == null ||
                        parseFloat(item?.vehicle?.vcc?.custom_charges_aed) ===
                          0) &&
                      (item?.vehicle?.vcc?.vat_charges_aed == null ||
                        parseFloat(item?.vehicle?.vcc?.vat_charges_aed) ===
                          0) &&
                      parseFloat(item?.invoice?.paid) === 0
                    )
                  }
                >
                  <Delete
                    sx={{ color: Colors.white, height: "16px !important" }}
                  />
                </IconButton>
                <Typography variant="body2" color={Colors.black}>
                  Delete
                </Typography>
              </Box>
            </Tooltip>
          )}

          {onClickgatePassDelete && (
            <Tooltip
              title={
                detail?.is_paid === false
                  ? "Gate pass for this vehicle has not paid"
                  : ""
              }
            >
              <Box component="div" className="dropdown-item">
                <IconButton
                  disabled={
                    detail?.is_paid === true && detail?.id !== latestDetail?.id
                  }
                  sx={{
                    bgcolor:
                      detail?.is_paid === true &&
                      detail?.is_paid === true &&
                      detail?.id !== latestDetail?.id
                        ? Colors.grey
                        : Colors.danger,
                    "&:hover": {
                      bgcolor:
                        detail?.is_paid === true &&
                        detail?.is_paid === true &&
                        detail?.id === latestDetail?.id
                          ? Colors.grey
                          : Colors.danger,
                    },
                  }}
                  className="icon"
                  onClick={() => {
                    onClickgatePassDelete();
                  }}
                >
                  <Delete
                    sx={{ color: Colors.white, height: "16px !important" }}
                  />
                </IconButton>
              </Box>
            </Tooltip>
          )}

          {item?.gate_pass?.is_approved &&
            item?.gate_pass?.is_paid === null &&
            item?.gate_pass?.is_valid === null &&
            item?.gate_pass?.total_due === null &&
            item?.gate_pass?.is_out !== true && (
              <div className="dropdown-item">
                <Box
                  sx={{ display: "flex", alignItems: "center" }}
                  onClick={() => {
                    navigate(`/create-gate-pass/${item.id}`);
                    closeMenu();
                  }}
                >
                  <IconButton
                    sx={{
                      bgcolor: Colors.primary,
                      "&:hover": { bgcolor: Colors.primary },
                      p: "8px",
                    }}
                  >
                    <CreateIcon />
                  </IconButton>
                  <Typography variant="body2">Create</Typography>
                </Box>
              </div>
            )}

          {/* ReCreate Gate Pass Button */}
          {permissions?.recreate &&
            item?.gate_pass?.is_valid === false &&
            item?.gate_pass?.details?.some((detail) => detail?.total_due) &&
            // item?.gate_pass?.details?.[0]?.total_due !== null &&
            item?.gate_pass?.is_out !== true && (
              <div className="dropdown-item">
                <Box
                  sx={{ display: "flex", alignItems: "center" }}
                  onClick={() => {
                    navigate(`/recreate-gate-pass/${item.id}`, {
                      state: { recreate: true },
                    });
                    closeMenu();
                  }}
                >
                  <IconButton
                    sx={{
                      bgcolor: Colors.primary,
                      "&:hover": { bgcolor: Colors.primary },
                      p: "8px",
                    }}
                  >
                    <CreateIcon />
                  </IconButton>
                  <Typography variant="body2">ReCreate</Typography>
                </Box>
              </div>
            )}

          {/* View Gate Pass Button */}
          {permissions?.view &&
            item?.gate_pass?.details?.some((detail) => detail?.total_due) && (
              <div className="dropdown-item">
                <Box
                  sx={{ display: "flex", alignItems: "center" }}
                  onClick={() => {
                    onClick1();
                    closeMenu();
                  }}
                >
                  <IconButton
                    sx={{
                      bgcolor: Colors.primary,
                      "&:hover": { bgcolor: Colors.primary },
                      p: "8px",
                    }}
                  >
                    <VisibilityIcon
                      sx={{ fontSize: "18px", color: "#FFFFFF" }}
                    />
                  </IconButton>
                  <Typography variant="body2">View</Typography>
                </Box>
              </div>
            )}

          {/* Payment Gate Pass Button */}
          {permissions?.payment &&
            !isValid &&
            item?.gate_pass?.details?.some((detail) => detail?.total_due > 0) &&
            item?.gate_pass?.details?.some((detail) => !detail?.is_paid) &&
            !(
              item?.gate_pass?.is_valid === false &&
              item?.gate_pass?.details?.every(
                (detail) => detail?.is_paid === false,
              )
            ) && (
              <Tooltip
                title={
                  item?.gate_pass?.is_valid === false &&
                  item?.gate_pass?.details?.some((detail) => !detail?.is_paid)
                    ? "Re-create first"
                    : ""
                }
                arrow
              >
                <div className="dropdown-item">
                  <Box
                    sx={{ display: "flex", alignItems: "center" }}
                    onClick={() => {
                      navigate(`/gate-pass/${item.id}`, { state: "payment" });
                      closeMenu();
                    }}
                  >
                    <IconButton
                      sx={{
                        bgcolor: Colors.smokeyGrey,
                        "&:hover": { bgcolor: Colors.smokeyGrey },
                        p: "8px",
                      }}
                    >
                      <CashIcon />
                    </IconButton>
                    <Typography variant="body2">Payment</Typography>
                  </Box>
                </div>
              </Tooltip>
            )}

          {EditReconcile && (
            <>
              <div className="dropdown-item">
                <Box
                  component={"div"}
                  onClick={
                    () => EditReconcile(item)
                    // (item?.creator?.id === user?.id
                    //   ? () => voucherEdit(item)
                    //   : undefined)
                  }
                >
                  <IconButton
                    sx={{
                      bgcolor: Colors.primary,
                      //  item.creator?.id === user?.id ? Colors.primary : Colors.grey,
                      "&:hover": {
                        bgcolor: Colors.primary,
                        // item.creator?.id === user?.id ? Colors.primary : Colors.grey
                      },
                      p: "8px",
                    }}
                  >
                    <Edit
                      sx={{
                        color: Colors.white,
                        // item.creator?.id === user?.id ? Colors.white : Colors.grey,
                        height: "16px !important",
                      }}
                    />
                  </IconButton>
                  <Typography variant="body2">Edit</Typography>
                </Box>
              </div>
            </>
          )}

          {DeleteReconcile && (
            <Tooltip
              title={
                !(item?.tran_type === "drafted") ? "its already submit" : ""
              }
              arrow
            >
              <div
                onClick={() => {
                  if (item?.tran_type === "drafted") {
                    DeleteReconcile();
                  }
                }}
                className="dropdown-item"
              >
                <IconButton
                  sx={{
                    bgcolor:
                      item?.tran_type === "drafted"
                        ? Colors.danger
                        : Colors.grey,
                    "&:hover": {
                      bgcolor:
                        item?.tran_type === "drafted"
                          ? Colors.danger
                          : Colors.grey,
                    },
                  }}
                  className="icon"
                  disabled={!(item?.tran_type === "drafted")}
                >
                  <Delete
                    sx={{
                      color:
                        item?.tran_type === "drafted"
                          ? Colors.white
                          : Colors.grey,
                      height: "16px !important",
                    }}
                  />
                </IconButton>
                <span>Delete</span>
              </div>
            </Tooltip>
          )}

          {voucher && (
            <>
              <div className="dropdown-item">
                <Box component={"div"} onClick={voucherView}>
                  <IconButton
                    sx={{
                      bgcolor: Colors.primary,
                      "&:hover": { bgcolor: Colors.primary },
                      p: "8px",
                    }}
                  >
                    <EyeIcon />
                  </IconButton>
                  <Typography variant="body2">View</Typography>
                </Box>
              </div>

              {permissions && permissions["delete_payment_voucher"] && (
                <>
                  {paymentVoucherEdit && (
                    <>
                      <div className="dropdown-item">
                        <Box
                          component={"div"}
                          onClick={
                            item?.new_voucher === true
                              ? () => paymentVoucherEdit(item)
                              : undefined
                          }
                        >
                          <IconButton
                            sx={{
                              bgcolor:
                                item?.new_voucher === true
                                  ? Colors.primary
                                  : Colors.grey,
                              "&:hover": {
                                bgcolor:
                                  item?.new_voucher === true
                                    ? Colors.primary
                                    : Colors.grey,
                              },
                              p: "8px",
                            }}
                          >
                            <Edit
                              sx={{
                                color:
                                  item?.new_voucher === true
                                    ? Colors.white
                                    : Colors.grey,
                                height: "16px !important",
                              }}
                            />
                          </IconButton>
                          <Typography variant="body2">Edit</Typography>
                        </Box>
                      </div>
                    </>
                  )}
                </>
              )}

              {permissions && permissions["edit_receipt_voucher"] && (
                <>
                  {receiptVoucherEdit && (
                    <>
                      <div className="dropdown-item">
                        <Box
                          component={"div"}
                          onClick={
                            item?.new_voucher === true
                              ? () => receiptVoucherEdit(item)
                              : undefined
                          }
                        >
                          <IconButton
                            sx={{
                              bgcolor:
                                item?.new_voucher === true
                                  ? Colors.primary
                                  : Colors.grey,
                              "&:hover": {
                                bgcolor:
                                  item?.new_voucher === true
                                    ? Colors.primary
                                    : Colors.grey,
                              },
                              p: "8px",
                            }}
                          >
                            <Edit
                              sx={{
                                color:
                                  item?.new_voucher === true
                                    ? Colors.white
                                    : Colors.grey,
                                height: "16px !important",
                              }}
                            />
                          </IconButton>
                          <Typography variant="body2">Edit</Typography>
                        </Box>
                      </div>
                    </>
                  )}
                </>
              )}

              {voucherEdit && (
                <>
                  <div className="dropdown-item">
                    <Box component={"div"} onClick={() => voucherEdit(item)}>
                      <IconButton
                        sx={{
                          bgcolor: Colors.primary,
                          "&:hover": {
                            bgcolor: Colors.primary,
                          },
                          p: "8px",
                        }}
                      >
                        <Edit
                          sx={{
                            color: Colors.white,
                            height: "16px !important",
                          }}
                        />
                      </IconButton>
                      <Typography variant="body2">Edit</Typography>
                    </Box>
                  </div>
                </>
              )}
              {(!iftv || isAdmin) && (
                <div className="dropdown-item">
                  <Box
                    component={"div"}
                    className="pdf-hide"
                    style={
                      (client &&
                        parseFloat(item?.invoice?.balance).toFixed(2) ===
                          parseFloat(item?.invoice?.total).toFixed(2)) ||
                      item?.is_reversed
                        ? {
                            opacity: 0.5,
                            pointerEvents: "none",
                          }
                        : {}
                    }
                    onClick={
                      (client &&
                        parseFloat(item?.invoice?.balance).toFixed(2) !==
                          parseFloat(item?.invoice?.total).toFixed(2)) ||
                      // && item?.creator?.id === user?.id
                      voucher
                        ? () => reverseVoucher(item)
                        : undefined
                    }
                  >
                    <IconButton
                      sx={{
                        bgcolor: Colors.primary,
                        // item.creator?.id === user?.id ? Colors.primary : Colors.grey,
                        "&:hover": {
                          bgcolor: Colors.primary,
                          //  item.creator?.id === user?.id ? Colors.primary : Colors.grey
                        },
                        p: "8px",
                      }}
                    >
                      <Edit
                        sx={{
                          color: Colors.white,
                          // item.creator?.id === user?.id ? Colors.white : Colors.grey,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography variant="body2">Reverse</Typography>
                  </Box>
                </div>
              )}
            </>
          )}

          {suplierListingView && (
            <Box
              onClick={() => {
                suplierListingView();
              }}
              sx={{ display: "flex", justifyContent: "start !important" }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <EyeIcon />
              </IconButton>
              <Typography variant="body2">View Details</Typography>
            </Box>
          )}
          {suplierListingEdit &&
            (permissions?.edit_supplier || user?.user_type == "A") && (
              <Box
                onClick={() => {
                  suplierListingEdit();
                }}
                sx={{ display: "flex", justifyContent: "start !important" }}
                className="dropdown-item"
              >
                <IconButton
                  sx={{
                    bgcolor: Colors.bluishCyan,
                    "&:hover": {
                      bgcolor: Colors.bluishCyan,
                    },
                  }}
                >
                  <Edit
                    sx={{
                      color: Colors.white,
                      height: "16px !important",
                    }}
                  />
                </IconButton>
                <Typography variant="body2">Edit Details</Typography>
              </Box>
            )}

          {suplierListingCompleteProfile && (
            <Box
              onClick={() => {
                suplierListingCompleteProfile();
              }}
              sx={{ display: "flex", justifyContent: "start !important" }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.bluishCyan,
                  "&:hover": {
                    bgcolor: Colors.bluishCyan,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <Typography variant="body2">Complete Profile</Typography>
            </Box>
          )}

          {BillApprove &&
            !item?.approved &&
            (permissions?.approve_unpaid_bills || user?.user_type == "A") && (
              <Box
                onClick={() => {
                  BillApprove();
                }}
                className="dropdown-item"
              >
                <IconButton
                  sx={{
                    bgcolor: Colors.primary,
                    "&:hover": {
                      bgcolor: Colors.primary,
                    },
                  }}
                >
                  <AccessTime style={{ color: "white", fontSize: "16px" }} />
                </IconButton>
                <Typography variant="body2">Approve Bill</Typography>
              </Box>
            )}

          {BillApprove !== undefined && item?.approved && (
            <Box className="dropdown-item">
              <IconButton
                sx={{
                  bgcolor: Colors.success,
                  "&:hover": {
                    bgcolor: Colors.success,
                  },
                }}
              >
                <Check style={{ color: "white", fontSize: "16px" }} />
              </IconButton>
              <Typography variant="body2">Approved</Typography>
            </Box>
          )}

          {paidBillsView && (
            <Box
              onClick={() => {
                paidBillsView();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <EyeIcon />
              </IconButton>
              <Typography variant="body2">View Receipt</Typography>
            </Box>
          )}

          {paidBillsDelete &&
            (permissions?.delete_paid_bills || user?.user_type == "A") && (
              <Box
                onClick={() => {
                  paidBillsDelete();
                }}
                className="dropdown-item"
              >
                <IconButton
                  sx={{
                    bgcolor: Colors.white,
                    "&:hover": {
                      bgcolor: Colors.primary,
                    },
                  }}
                >
                  <Delete />
                </IconButton>
                <Typography variant="body2" sx={{ color: Colors.danger }}>
                  Delete
                </Typography>
              </Box>
            )}

          {BillView && (
            <Box
              onClick={() => {
                BillView();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <EyeIcon />
              </IconButton>
              <Typography variant="body2">View Vendor Bill</Typography>
            </Box>
          )}

          {BillEdit && (permissions?.edit_bills || user?.user_type == "A") && (
            <Box
              onClick={() => {
                if (!isPaid) {
                  BillEdit();
                }
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                opacity: isPaid ? 0.6 : 1,
                // pointerEvents: isPaid ? "none" : "auto",
                cursor: "pointer",
              }}
              className="dropdown-item"
            >
              <IconButton
                // disabled={isPaid}
                sx={{
                  bgcolor: isPaid ? "#b9b9b9" : Colors.bluishCyan,
                  "&:hover": {
                    bgcolor: isPaid ? "#a39e9e" : Colors.bluishCyan,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>

              <Typography
                variant="body2"
                sx={{
                  color: isPaid ? "#9E9E9E" : "inherit",
                }}
              >
                Edit Bill
              </Typography>
            </Box>
          )}
          {/* {BillEdit && (permissions?.edit_bills || user?.user_type == "A") && (
            <Box
              onClick={() => {
                BillEdit();
              }}
              sx={{ display: "flex", justifyContent: "start !important" }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.bluishCyan,
                  "&:hover": {
                    bgcolor: Colors.bluishCyan,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <Typography variant="body2">Edit Bill</Typography>
            </Box>
          )} */}

          {BillDelete &&
            (permissions?.delete_unpaid_bills || user?.user_type == "A") && (
              <Box
                onClick={() => {
                  BillDelete();
                }}
                sx={{ display: "flex", justifyContent: "start !important" }}
                className="dropdown-item"
              >
                <IconButton
                  sx={{
                    bgcolor: Colors.danger,
                    "&:hover": {
                      bgcolor: Colors.danger,
                    },
                  }}
                >
                  <Delete
                    sx={{
                      color: Colors.white,
                      height: "16px !important",
                    }}
                  />
                </IconButton>
                <Typography variant="body2" sx={{ color: Colors.secondary }}>
                  Delete
                </Typography>
              </Box>
            )}

          {vendorViewDetail && (
            <Box
              onClick={() => {
                onClick1(item);
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <EyeIcon />
              </IconButton>
              <Typography variant="body2">Detail View</Typography>
            </Box>
          )}

          {vendorEdit && (
            <Box
              onClick={() => {
                onEdit(id, item);
              }}
              sx={{ display: "flex", justifyContent: "start !important" }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.bluishCyan,
                  "&:hover": {
                    bgcolor: Colors.bluishCyan,
                  },
                }}
              >
                <Edit
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <Typography variant="body2">Edit</Typography>
            </Box>
          )}

          {/* WhatsApp Option */}
          {whatsAppItem && !vccIssue && (
            <>
              <div className="dropdown-item">
                <Box
                  component={"div"}
                  onClick={() => {
                    whatsAppClick(whatsAppItem);
                    closeMenu();
                  }}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <IconButton
                    sx={{
                      bgcolor: Colors.primary,
                      "&:hover": { bgcolor: Colors.primary },
                      p: "8px",
                    }}
                  >
                    <WhatsApp sx={{ fontSize: "18px", color: "#FFFFFF" }} />
                  </IconButton>
                  <Typography variant="body2" sx={{ fontSize: "12px" }}>
                    WhatsApp
                  </Typography>
                </Box>
              </div>

              {/* Email Option */}
              <div className="dropdown-item">
                <Box
                  component={"div"}
                  onClick={() => {
                    emailClick();
                    closeMenu();
                  }}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <IconButton sx={{ p: "8px" }}>
                    <EmailIcon sx={{ fontSize: "18px", color: Colors.blue }} />
                  </IconButton>
                  <Typography variant="body2" sx={{ fontSize: "12px" }}>
                    Email
                  </Typography>
                </Box>
              </div>
            </>
          )}
          {/* Delete Invoice Option */}

          {(permissions?.["delete-payments-history"] || isAdmin) &&
            !client &&
            !customVat &&
            !depositView &&
            !vccIssue && (
              <Tooltip
                title={
                  isInvoiceDeleteBlocked
                    ? item?.available_tt
                      ? "This vehicle is under the Vehicle Remittance Plan."
                      : "Delete disabled: payment is done and container is added."
                    : item?.booking?.vehicle?.client_costings
                      ? "Client Costing Already Applied."
                      : ""
                }
                arrow
              >
                <div
                  onClick={() => {
                    if (
                      !item?.booking?.vehicle?.client_costings &&
                      !isInvoiceDeleteBlocked
                    ) {
                      deleteInvoice(item?.id);
                      closeMenu();
                    }
                  }}
                  className="dropdown-item"
                  style={{
                    cursor:
                      item?.booking?.vehicle?.client_costings ||
                      isInvoiceDeleteBlocked
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      item?.booking?.vehicle?.client_costings ||
                      isInvoiceDeleteBlocked
                        ? 0.5
                        : 1,
                  }}
                >
                  <Delete
                    sx={{
                      color: Colors.danger,
                    }}
                    className="icon"
                  />
                  <span>Delete</span>
                </div>
              </Tooltip>
            )}
          {/* Vouchers Options and Client Costing Options */}
          {permissions?.["delete-unpaid-paid-invoices"] &&
            !customVat &&
            !depositView &&
            !vccIssue && (
              <div className="dropdown-item">
                <Box
                  component={"div"}
                  onClick={() => {
                    if (
                      parseFloat(item?.invoice?.balance).toFixed(2) !==
                      parseFloat(item?.invoice?.total).toFixed(2)
                    ) {
                      onClickDeletepaidunpaidV1();
                    }
                  }}
                  sx={{ mr: "12px" }}
                >
                  <IconButton
                    sx={{
                      bgcolor:
                        parseFloat(item?.invoice?.balance).toFixed(2) ===
                        parseFloat(item?.invoice?.total).toFixed(2)
                          ? Colors.grey
                          : Colors.red,
                      "&:hover": {
                        bgcolor:
                          parseFloat(item?.invoice?.balance).toFixed(2) ===
                          parseFloat(item?.invoice?.total).toFixed(2)
                            ? Colors.grey
                            : Colors.red,
                      },
                    }}
                    disabled={
                      parseFloat(item?.invoice?.balance).toFixed(2) ===
                      parseFloat(item?.invoice?.total).toFixed(2)
                    }
                  >
                    <Delete />
                  </IconButton>
                  <Typography
                    variant="body2"
                    color={
                      parseFloat(item?.invoice?.balance).toFixed(2) ===
                      parseFloat(item?.invoice?.total).toFixed(2)
                        ? Colors.grey
                        : "inherit"
                    }
                  >
                    Delete
                  </Typography>
                </Box>
              </div>
            )}

          {permissions?.["delete-unpaid-paid-invoices-V2"] &&
            !customVat &&
            !depositView &&
            !vccIssue && (
              <div className="dropdown-item">
                <Box
                  component={"div"}
                  onClick={() => {
                    if (
                      parseFloat(item?.invoice?.balance).toFixed(2) !==
                      parseFloat(item?.invoice?.total).toFixed(2)
                    ) {
                      onClickDeletepaidunpaidV2();
                    }
                  }}
                  sx={{ mr: "12px" }}
                >
                  <IconButton
                    sx={{
                      bgcolor:
                        parseFloat(item?.invoice?.balance).toFixed(2) ===
                        parseFloat(item?.invoice?.total).toFixed(2)
                          ? Colors.grey
                          : Colors.red,
                      "&:hover": {
                        bgcolor:
                          parseFloat(item?.invoice?.balance).toFixed(2) ===
                          parseFloat(item?.invoice?.total).toFixed(2)
                            ? Colors.grey
                            : Colors.red,
                      },
                    }}
                    disabled={
                      parseFloat(item?.invoice?.balance).toFixed(2) ===
                      parseFloat(item?.invoice?.total).toFixed(2)
                    }
                  >
                    <Delete />
                  </IconButton>
                  <Typography
                    variant="body2"
                    color={
                      parseFloat(item?.invoice?.balance).toFixed(2) ===
                      parseFloat(item?.invoice?.total).toFixed(2)
                        ? Colors.grey
                        : "inherit"
                    }
                  >
                    Delete
                  </Typography>
                </Box>
              </div>
            )}
          {permissions?.["delete-gp"] && (
            <Tooltip
              title={
                !hasUnpaid
                  ? "Gate pass for this vehicle has already been paid"
                  : ""
              }
            >
              <div
                className={`dropdown-item`}
                onClick={() => {
                  if (hasUnpaid) {
                    onDeleteClick();
                  }
                }}
              >
                <IconButton
                  disabled={!hasUnpaid}
                  sx={{
                    bgcolor: hasUnpaid ? Colors.danger : Colors.grey,
                    "&:hover": {
                      bgcolor: hasUnpaid ? Colors.danger : Colors.grey,
                    },
                  }}
                  className="icon"
                >
                  <Delete
                    sx={{
                      color: Colors.white,
                      height: "16px !important",
                    }}
                  />
                </IconButton>
                <span>Delete</span>
              </div>
            </Tooltip>
          )}

          {is_consignment && (
            <>
              <div
                onClick={() => {
                  consignmentView(id, item);
                  closeMenu();
                }}
                className="dropdown-item"
              >
                <IconButton
                  sx={{
                    bgcolor:
                      user?.role_id === 1000 ||
                      item?.rm_id === user?.id ||
                      user?.id === 56197 ||
                      user?.id === 50917 ||
                      user?.id === 56743 ||
                      item?.rm_id === 50926 ||
                      item?.rm_id === 56212
                        ? Colors.bluishCyan
                        : Colors.red,
                    "&:hover": {
                      bgcolor:
                        user?.role_id === 1000 ||
                        item?.rm_id === user?.id ||
                        user?.id === 56197 ||
                        user?.id === 50917 ||
                        user?.id === 56743 ||
                        item?.rm_id === 50926 ||
                        item?.rm_id === 56212
                          ? Colors.bluishCyan
                          : Colors.red,
                    },
                  }}
                  className="icon"
                  disabled={
                    user?.role_id !== 1000 ||
                    item?.rm_id !== user?.id ||
                    user?.id !== 56197 ||
                    user?.id !== 50917 ||
                    user?.id !== 56743 ||
                    item?.rm_id !== 50926 ||
                    item?.rm_id !== 56212
                  }
                >
                  <VisibilityIcon
                    sx={{
                      color:
                        user?.role_id === 1000 ||
                        item?.rm_id === user?.id ||
                        user?.id === 56197 ||
                        user?.id === 50917 ||
                        user?.id === 56743 ||
                        item?.rm_id === 50926 ||
                        item?.rm_id === 56212
                          ? Colors.black
                          : Colors.grey,

                      // color: Colors.white,
                      height: "16px !important",
                    }}
                  />
                </IconButton>
                <span>Consignment Invoice</span>
              </div>

              {is_dock_receipt && (
                <div
                  onClick={() => {
                    dockReceiptView(id, item);
                    closeMenu();
                  }}
                  className="dropdown-item"
                >
                  <IconButton
                    sx={{
                      bgcolor:
                        user?.role_id === 1000 ||
                        item?.rm_id === user?.id ||
                        user?.id === 56197 ||
                        user?.id === 50917 ||
                        user?.id === 56743 ||
                        item?.rm_id === 50926 ||
                        item?.rm_id === 56212
                          ? Colors.bluishCyan
                          : Colors.red,
                      "&:hover": {
                        bgcolor:
                          user?.role_id === 1000 ||
                          item?.rm_id === user?.id ||
                          user?.id === 56197 ||
                          user?.id === 50917 ||
                          user?.id === 56743 ||
                          item?.rm_id === 50926 ||
                          item?.rm_id === 56212
                            ? Colors.bluishCyan
                            : Colors.red,
                      },
                    }}
                    className="icon"
                    disabled={
                      user?.role_id !== 1000 ||
                      item?.rm_id !== user?.id ||
                      user?.id !== 56197 ||
                      user?.id !== 50917 ||
                      user?.id !== 56743 ||
                      item?.rm_id !== 50926 ||
                      item?.rm_id !== 56212
                    }
                  >
                    <VisibilityIcon
                      sx={{
                        color:
                          user?.role_id === 1000 ||
                          item?.rm_id === user?.id ||
                          user?.id === 56197 ||
                          user?.id === 50917 ||
                          user?.id === 56743 ||
                          item?.rm_id === 50926 ||
                          item?.rm_id === 56212
                            ? Colors.black
                            : Colors.grey,

                        // color: Colors.white,
                        height: "16px !important",
                      }}
                    />
                  </IconButton>
                  <span>Dock Receipt</span>
                </div>
              )}
            </>
          )}

          {/* View Detail Option */}
          {permissions?.detail_view && (
            <div
              onClick={() => {
                onClick1(id, item);
                closeMenu();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor:
                    user?.role_id === 1000 ||
                    item?.rm_id === user?.id ||
                    user?.id === 56197 ||
                    user?.id === 50917 ||
                    user?.id === 56743 ||
                    item?.rm_id === 50926 ||
                    item?.rm_id === 56212
                      ? Colors.bluishCyan
                      : Colors.red,
                  "&:hover": {
                    bgcolor:
                      user?.role_id === 1000 ||
                      item?.rm_id === user?.id ||
                      user?.id === 56197 ||
                      user?.id === 50917 ||
                      user?.id === 56743 ||
                      item?.rm_id === 50926 ||
                      item?.rm_id === 56212
                        ? Colors.bluishCyan
                        : Colors.red,
                  },
                }}
                className="icon"
                disabled={
                  user?.role_id !== 1000 ||
                  item?.rm_id !== user?.id ||
                  user?.id !== 56197 ||
                  user?.id !== 50917 ||
                  user?.id !== 56743 ||
                  item?.rm_id !== 50926 ||
                  item?.rm_id !== 56212
                }
              >
                <VisibilityIcon
                  sx={{
                    color:
                      user?.role_id === 1000 ||
                      item?.rm_id === user?.id ||
                      user?.id === 56197 ||
                      user?.id === 50917 ||
                      user?.id === 56743 ||
                      item?.rm_id === 50926 ||
                      item?.rm_id === 56212
                        ? Colors.black
                        : Colors.grey,

                    // color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <span>View Detail</span>
            </div>
          )}
          {/* Buyer ID Detail Option */}

          {item?.request?.finance_status === false && (
            <>
              {permissions?.detail_buyer && item?.request && (
                <div
                  onClick={() => {
                    navigate(`/buyer-id-detail/${item.id}`);
                    closeMenu();
                  }}
                  className="dropdown-item"
                >
                  <IconButton
                    className="icon"
                    sx={{
                      bgcolor: Colors.blackShade,
                      "&:hover": { bgcolor: Colors.blackShade },
                    }}
                  >
                    <RequestBuyerIdIcon />
                  </IconButton>
                  <span>Buyer ID Detail</span>
                </div>
              )}
            </>
          )}

          {/* Edit Booked vehicle */}
          {permissions?.edit && (
            <div
              onClick={() => {
                onEdit(id, item);
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.bluishCyan,
                  "&:hover": { bgcolor: Colors.bluishCyan },
                }}
                className="icon"
              >
                <Edit sx={{ color: Colors.white, height: "16px !important" }} />
              </IconButton>
              <span>Edit</span>
            </div>
          )}

          {/* {permissions?.edit && (
            <div
              onClick={() => {
                onEditVehicleBooking(id, item);
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.bluishCyan,
                  "&:hover": { bgcolor: Colors.bluishCyan },
                }}
                className="icon"
              >
                <Edit sx={{ color: Colors.white, height: "16px !important" }} />
              </IconButton>
              <span>Edit V2</span>
            </div>
          )} */}

          {onClickUpdateSalesInfo && (
            <>
              <div
                onClick={() => {
                  onClickUpdateSalesInfo();
                }}
                className="dropdown-item"
              >
                <IconButton sx={{}} className="icon">
                  <Edit
                    sx={{
                      color: Colors.black,
                      height: "20px !important",
                    }}
                  />
                </IconButton>
                <span>Update Sales Info</span>
              </div>
            </>
          )}

          {/*Damages*/}

          {onClickViewDamages && (
            <div
              onClick={() => {
                onClickViewDamages();
              }}
              className="dropdown-item"
            >
              <VisibilityIcon
                className="icon"
                sx={{ color: Colors.black, height: "18px !important" }}
              />
              <span>View</span>
            </div>
          )}

          {onClickEditDamages && (
            <Tooltip
              title={
                item?.claimed_amount
                  ? "This vehicle has already been claimed. Please delete it to edit damage"
                  : ""
              }
              arrow
              placement="top"
            >
              <div
                style={{
                  opacity: item?.claimed_amount ? 0.5 : 1,
                }}
                onClick={() => {
                  if (!item?.claimed_amount) {
                    onClickEditDamages();
                  }
                }}
                className="dropdown-item"
              >
                <Edit
                  className="icon"
                  sx={{ color: Colors.black, height: "18px !important" }}
                />
                <span>Edit</span>
              </div>
            </Tooltip>
          )}

          {onClickUpdateDamagesClaim && (
            <Tooltip
              title={
                item?.claimed_amount
                  ? "This vehicle has already been claimed. Please delete it to update"
                  : ""
              }
              arrow
              placement="top"
            >
              <div
                style={{
                  opacity: item?.claimed_amount ? 0.5 : 1,
                }}
                onClick={() => {
                  if (!item?.claimed_amount) {
                    onClickUpdateDamagesClaim();
                  }
                }}
                className="dropdown-item"
              >
                <Edit
                  className="icon"
                  sx={{ color: Colors.black, height: "18px !important" }}
                />
                <span>Update Claim</span>
              </div>
            </Tooltip>
          )}

          {onClickDamagesNotes && (
            <div
              onClick={() => {
                onClickDamagesNotes();
              }}
              className="dropdown-item"
            >
              <Edit
                className="icon"
                sx={{ color: Colors.black, height: "18px !important" }}
              />
              <span>Update Notes</span>
            </div>
          )}
          {onClickViewDamageClaimNotes && (
            <div
              onClick={() => {
                onClickViewDamageClaimNotes();
              }}
              className="dropdown-item"
            >
              <VisibilityIcon
                className="icon"
                sx={{ color: Colors.black, height: "18px !important" }}
              />
              <span>View</span>
            </div>
          )}

          {onClickEditDamageClaimNotes && (
            <div
              onClick={() => {
                onClickEditDamageClaimNotes();
              }}
              className="dropdown-item"
            >
              <Edit
                className="icon"
                sx={{ color: Colors.black, height: "18px !important" }}
              />
              <span>Add Notes</span>
            </div>
          )}

          {onClickDeleteDamages && (
            <div
              onClick={() => {
                onClickDeleteDamages();
              }}
              className="dropdown-item"
            >
              <Delete
                className="icon"
                sx={{ color: "red", height: "18px !important" }}
              />
              <span>Delete</span>
            </div>
          )}

          {onClickViewDamageClaimNotes && (
            <div
              onClick={() => {
                onClickViewDamageClaimNotes();
              }}
              className="dropdown-item"
            >
              <VisibilityIcon
                className="icon"
                sx={{ color: Colors.black, height: "18px !important" }}
              />
              <span>View</span>
            </div>
          )}

          {onClickEditDamageClaimNotes && (
            <div
              onClick={() => {
                onClickEditDamageClaimNotes();
              }}
              className="dropdown-item"
            >
              <Edit
                className="icon"
                sx={{ color: Colors.black, height: "18px !important" }}
              />
              <span>Add Notes</span>
            </div>
          )}

          {onClickAssignPermission && (
            <div
              onClick={() => {
                onClickAssignPermission();
              }}
              className="dropdown-item"
            >
              <Edit className="icon" />
              <span>Permission</span>
            </div>
          )}
          {/* Edit Container Option */}
          {permissions?.update_shipping && (
            <div
              onClick={() => {
                onClick2(id, item);
                closeMenu();
              }}
              className="dropdown-item"
            >
              <Edit className="icon" />
              <span>Edit Container</span>
            </div>
          )}

          {/* Allocate/De-allocate Option */}
          {/* {permissions?.allocate && item?.request && (
            <div
              onClick={() => {
                onAllocateClick(item);
                closeMenu();
              }}
              className="dropdown-item"
            >
              <Edit className="icon" />
              <span>
                {item?.request?.allocation_status === "allocated" ||
                item?.request?.allocation_status === "issued"
                  ? "De-Allocate"
                  : "Allocate"}
              </span>
            </div>
          )} */}

          {onBuyerIdAllocation && (
            <>
              <div
                onClick={() => {
                  if (item?.request?.id) {
                    onBuyerIdAllocation();
                  } else {
                    ErrorToaster(
                      "Can Not Allocate Buyer ID First Receive Deposit",
                    );
                  }
                  closeMenu();
                }}
                className="dropdown-item"
              >
                <Edit className="icon" />
                <span>{"Buyer ID's Allocation"}</span>
              </div>
            </>
          )}

          {/* Message Option */}
          {/* {permissions?.message && (
            <div
              onClick={() => {
                onMessageClick(item);
                closeMenu();
              }}
              className="dropdown-item"
            >
              <MessageIcon className="icon" />
              <span>Message</span>
            </div>
          )} */}
          {/* Request Buyer ID Option */}
          {permissions?.request && !item?.request && !isForward && (
            <div
              onClick={() => {
                navigate(`/request-buyer-id/${item.id}`);
                closeMenu();
              }}
              className="dropdown-item"
            >
              <IconButton
                className="icon"
                sx={{
                  bgcolor: Colors.bluishCyan,
                  "&:hover": { bgcolor: Colors.bluishCyan },
                }}
              >
                <RequestBuyerIdIcon />
              </IconButton>
              <span>Recv-Deposit</span>
            </div>
          )}
          {/* Delete Container Option */}
          {permissions?.["delete-container"] && (
            <div
              onClick={() => {
                if (canDelete) {
                  setOpenDelete(true);
                  setShippingId(item?.shipping_id);
                } else {
                  ErrorToaster(
                    "Client Costing or Vendor Costing is already performed for this container",
                  );
                }
                closeMenu();
              }}
              className={`dropdown-item ${
                canDelete ? "cursor-pointer" : "disabled cursor-not-allowed"
              }`}
              style={{ pointerEvents: canDelete ? "auto" : "none" }}
            >
              <Delete sx={{ color: "red" }} className="icon" />
              <span>Delete Container</span>
            </div>
          )}

          {vendorApplyFund && (
            <Box
              onClick={() => {
                if (!item?.approval_pending) {
                  navigate(`/vendor-funds-apply`, {
                    state: item,
                  });
                } else {
                  ErrorToaster("Approve Pending Payments");
                }
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.primary,
                  "&:hover": {
                    bgcolor: Colors.primary,
                  },
                }}
              >
                <AttachMoneyIcon sx={{ color: "#fff" }} />
              </IconButton>
              <Typography variant="body2">Apply Fund</Typography>
            </Box>
          )}
          {deleteReferri && (
            <div
              onClick={() => {
                onDeleteClick();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.danger,
                  "&:hover": {
                    bgcolor: Colors.danger,
                  },
                }}
                className="icon"
              >
                <Delete
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <span>Delete</span>
            </div>
          )}

          {vendorDeleteIcon && (
            <div
              onClick={() => {
                onDeleteClick();
              }}
              className="dropdown-item"
            >
              <IconButton
                sx={{
                  bgcolor: Colors.danger,
                  "&:hover": {
                    bgcolor: Colors.danger,
                  },
                }}
                className="icon"
              >
                <Delete
                  sx={{
                    color: Colors.white,
                    height: "16px !important",
                  }}
                />
              </IconButton>
              <span>Delete</span>
            </div>
          )}

          {/* Recive Exit Paper */}
          {receiveCec && (
            <Box
              sx={{ flexDirection: "column" }}
              // className=""
            >
              {(permissions?.["reverse-cec"] || user.user_type == "A") && (
                <Tooltip
                  title={
                    item?.exit_paper_received
                      ? "Exit Paper Not Received!"
                      : parseFloat(item?.exit_paper_received)
                        ? "Shipping Paid. Can't Reverse!"
                        : ""
                  }
                  arrow
                  placement="top"
                >
                  <Box
                    component="div"
                    className="pdf-hide dropdown-item"
                    style={{
                      opacity: parseFloat(item?.exit_paper_received),
                    }}
                    //  sx={{ display: "flex", justifyContent: "start !important" }}
                    onClick={onClickReverseEP}
                  >
                    <IconButton
                      sx={{
                        bgcolor: parseFloat(item?.exit_paper_received)
                          ? Colors.grey
                          : Colors.bluishCyan,
                        "&:hover": {
                          bgcolor: parseFloat(item?.exit_paper_received)
                            ? Colors.grey
                            : Colors.bluishCyan,
                        },
                      }}
                      disabled={item?.exit_paper_received}
                    >
                      <Edit
                        sx={{
                          color: item?.exit_paper_received
                            ? Colors.grey
                            : Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color: item?.exit_paper_received
                          ? Colors.grey
                          : Colors.bluishCyan,
                      }}
                    >
                      Reverse EP
                    </Typography>
                  </Box>
                </Tooltip>
              )}

              {(permissions?.["reverse-cec"] || user.user_type == "A") && (
                <Tooltip arrow placement="top">
                  <Box
                    component="div"
                    className="pdf-hide dropdown-item"
                    style={{
                      opacity: daysRemaining === 0,
                    }}
                    //  sx={{ display: "flex", justifyContent: "start !important" }}
                    onClick={onClickCustomCharge}
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          daysRemaining === 0 ? Colors.grey : Colors.bluishCyan,
                        "&:hover": {
                          bgcolor:
                            daysRemaining !== 0
                              ? Colors.grey
                              : Colors.bluishCyan,
                        },
                      }}
                      disabled={
                        daysRemaining !== 0 || item?.exit_paper_received
                      }
                    >
                      <Edit
                        sx={{
                          color:
                            daysRemaining !== 0 ? Colors.grey : Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color:
                          daysRemaining !== 0 ? Colors.grey : Colors.bluishCyan,
                      }}
                    >
                      Custom Charge
                    </Typography>
                  </Box>
                </Tooltip>
              )}

              {/* {(permissions?.["reverse-cec"] || user.user_type == "A") && (
                <Tooltip
                  title={
                    !(item?.exit_paper_received && item?.exit_paper_received_at)
                      ? "Exit Paper Not Received!"
                      : parseFloat(item?.shipping?.shipping_paid) >=
                        parseFloat(item?.shipping?.shipping_total)
                        ? "Shipping Paid. Can't Reverse!"
                        : ""
                  }
                  arrow
                  placement="top"
                >
                  <Box
                    component="div"
                    className="pdf-hide"
                    style={{
                      opacity:
                        !(
                          item?.exit_paper_received &&
                          item?.exit_paper_received_at
                        ) ||
                        parseFloat(item?.shipping?.shipping_paid) >=
                        parseFloat(item?.shipping?.shipping_total),
                    }}
                    sx={{ display: "flex", justifyContent: "start !important" }}
                    onClick={onClickReverseVCC}
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          !(
                            item?.exit_paper_received &&
                            item?.exit_paper_received_at
                          ) ||
                            parseFloat(item?.shipping?.shipping_paid) >=
                            parseFloat(item?.shipping?.shipping_total)
                            ? Colors.grey
                            : Colors.bluishCyan,
                        "&:hover": {
                          bgcolor:
                            !(
                              item?.exit_paper_received &&
                              item?.exit_paper_received_at
                            ) ||
                              parseFloat(item?.shipping?.shipping_paid) >=
                              parseFloat(item?.shipping?.shipping_total)
                              ? Colors.grey
                              : Colors.bluishCyan,
                        },
                      }}
                      disabled={
                        !(
                          item?.exit_paper_received &&
                          item?.exit_paper_received_at
                        ) ||
                        parseFloat(item?.shipping?.shipping_paid) >=
                        parseFloat(item?.shipping?.shipping_total)
                      }
                    >
                      <Edit
                        sx={{
                          color:
                            !(
                              item?.exit_paper_received &&
                              item?.exit_paper_received_at
                            ) ||
                              parseFloat(item?.shipping?.shipping_paid) >=
                              parseFloat(item?.shipping?.shipping_total)
                              ? Colors.grey
                              : Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color:
                          !(
                            item?.exit_paper_received &&
                            item?.exit_paper_received_at
                          ) ||
                            parseFloat(item?.shipping?.shipping_paid) >=
                            parseFloat(item?.shipping?.shipping_total)
                            ? Colors.grey
                            : Colors.bluishCyan,
                      }}
                    >
                      Reverse
                    </Typography>
                  </Box>
                </Tooltip>
              )} */}

              {onClickReverseExitPaper && (
                <Tooltip
                  // title={
                  //   !(item?.exit_paper_received && item?.exit_paper_received_at)
                  //     ? "Exit Paper Not Received!"
                  //     : parseFloat(item?.shipping?.shipping_paid) >=
                  //       parseFloat(item?.shipping?.shipping_total)
                  //       ? "Shipping Paid. Can't Reverse!"
                  //       : ""
                  // }
                  arrow
                  placement="top"
                >
                  <Box
                    component="div"
                    className="pdf-hide"
                    style={{
                      opacity: item?.exit_paper_received === true,
                    }}
                    sx={{ display: "flex", justifyContent: "start !important" }}
                    onClick={onClickReverseExitPaper}
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          item?.exit_paper_received === true
                            ? Colors.grey
                            : Colors.bluishCyan,
                        "&:hover": {
                          bgcolor:
                            parseFloat(item?.shipping?.shipping_paid) >=
                            parseFloat(item?.shipping?.shipping_total)
                              ? Colors.grey
                              : Colors.bluishCyan,
                        },
                      }}
                      disabled={item?.exit_paper_received === true}
                    >
                      <Edit
                        sx={{
                          color:
                            item?.exit_paper_received === true
                              ? Colors.grey
                              : Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color:
                          item?.exit_paper_received === true
                            ? Colors.grey
                            : Colors.bluishCyan,
                      }}
                    >
                      Reverse To GCC
                    </Typography>
                  </Box>
                </Tooltip>
              )}

              {(permissions?.["delete-cec"] || user.user_type == "A") && (
                <Tooltip
                  title={
                    !(item?.exit_paper_received && item?.exit_paper_received_at)
                      ? "Exit Paper Not Received!"
                      : parseFloat(item?.shipping?.shipping_paid) >=
                          parseFloat(item?.shipping?.shipping_total)
                        ? "Shipping Paid. Can't Delete!"
                        : ""
                  }
                  arrow
                  placement="top"
                >
                  <Box
                    component="div"
                    className="pdf-hide dropdown-item"
                    style={{
                      opacity:
                        !(
                          item?.exit_paper_received &&
                          item?.exit_paper_received_at
                        ) ||
                        parseFloat(item?.shipping?.shipping_paid) >=
                          parseFloat(item?.shipping?.shipping_total)
                          ? 0.5
                          : 1,
                    }}
                    // sx={{ display: "flex", justifyContent: "start !important" }}
                    onClick={onClickDeleteVCC}
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          !(
                            item?.exit_paper_received &&
                            item?.exit_paper_received_at
                          ) ||
                          parseFloat(item?.shipping?.shipping_paid) >=
                            parseFloat(item?.shipping?.shipping_total)
                            ? Colors.grey
                            : Colors.error,
                        "&:hover": {
                          bgcolor:
                            !(
                              item?.exit_paper_received &&
                              item?.exit_paper_received_at
                            ) ||
                            parseFloat(item?.shipping?.shipping_paid) >=
                              parseFloat(item?.shipping?.shipping_total)
                              ? Colors.grey
                              : Colors.errorDark,
                        },
                      }}
                      disabled={
                        !(
                          item?.exit_paper_received &&
                          item?.exit_paper_received_at
                        ) ||
                        parseFloat(item?.shipping?.shipping_paid) >=
                          parseFloat(item?.shipping?.shipping_total)
                      }
                    >
                      <Delete
                        sx={{
                          color: !(
                            item?.exit_paper_received &&
                            item?.exit_paper_received_at
                          )
                            ? // ||
                              //   parseFloat(item?.shipping?.shipping_paid) >=
                              //   parseFloat(item?.shipping?.shipping_total)
                              Colors.grey
                            : Colors.red,
                          height: "20px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color: !(
                          item?.exit_paper_received &&
                          item?.exit_paper_received_at
                        )
                          ? // ||
                            //   parseFloat(item?.shipping?.shipping_paid) >=
                            //   parseFloat(item?.shipping?.shipping_total)
                            Colors.grey
                          : Colors.error,
                      }}
                    >
                      Delete
                    </Typography>
                  </Box>
                </Tooltip>
              )}
            </Box>
          )}
          {!receiveCec && salesCertificate && (
            <>
              {/* IssueMobaya */}
              {(permissions?.["reverse-mobaya"] || user?.user_type == "A") && (
                <Tooltip
                  title={
                    parseFloat(item?.vcc?.custom_paid) > 0 &&
                    parseFloat(item?.vcc?.vat_paid) > 0
                      ? "Invoice is already paid."
                      : ""
                  }
                  arrow
                  placement="top"
                >
                  <Box
                    onClick={onClickReverseIssueMobaya}
                    sx={{
                      cursor: "pointer",
                    }}
                    className="dropdown-item"
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          parseFloat(item?.vcc?.custom_paid) > 0 &&
                          parseFloat(item?.vcc?.vat_paid) > 0
                            ? Colors.grey
                            : Colors.blackShade,
                        "&:hover": {
                          bgcolor:
                            parseFloat(item?.vcc?.custom_paid) > 0 &&
                            parseFloat(item?.vcc?.vat_paid) > 0
                              ? Colors.grey
                              : Colors.blackShade,
                        },
                      }}
                      disabled={
                        parseFloat(item?.vcc?.custom_paid) > 0 &&
                        parseFloat(item?.vcc?.vat_paid) > 0
                      }
                      // sx={{
                      //   bgcolor: Colors.blackShade,
                      //   "&:hover": {
                      //     bgcolor: Colors.blackShade,
                      //   },
                      // }}
                    >
                      <Edit
                        sx={{
                          color:
                            parseFloat(item?.vcc?.custom_paid) > 0 &&
                            parseFloat(item?.vcc?.vat_paid) > 0
                              ? Colors.grey
                              : Colors.white,
                          // color: Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color:
                          parseFloat(item?.vcc?.custom_paid) > 0 &&
                          parseFloat(item?.vcc?.vat_paid) > 0
                            ? Colors.grey
                            : Colors.blackShade,
                        // color: Colors.blackShade,
                      }}
                    >
                      Reverse
                    </Typography>
                  </Box>
                </Tooltip>
              )}

              {onClickNotesIssueMobaya &&
                (() => {
                  const validation = creditNoteValidation ?? {
                    isValid: false,
                    message: "",
                  };

                  return (
                    <Tooltip title={validation.message} arrow placement="top">
                      <Box
                        component={"div"}
                        onClick={onClickNotesIssueMobaya}
                        className="dropdown-item"
                      >
                        <IconButton
                          className="icon"
                          sx={{
                            bgcolor: validation.isValid
                              ? Colors.primary
                              : Colors.grey,
                            "&:hover": {
                              bgcolor: validation.isValid
                                ? Colors.primary
                                : Colors.grey,
                            },
                          }}
                          disabled={!validation.isValid}
                        >
                          <Edit
                            sx={{
                              color: Colors.white,
                              height: "16px !important",
                            }}
                          />
                        </IconButton>
                        <Typography
                          sx={{
                            color: validation.isValid
                              ? Colors.black
                              : Colors.grey,
                          }}
                        >
                          Issue Credit Note
                        </Typography>
                      </Box>
                    </Tooltip>
                  );
                })()}

              {/* {onClickNotesIssueMobaya && (
                <Tooltip
                  title={
                    item?.mobaya_reference === null && parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2) && item?.vcc?.shipping?.shipping_paid >= item?.vcc?.shipping?.shipping_total || parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2)
                      ? "Reference Number is not added"
                      : ""
                  }
                  arrow
                  placement="top"
                >
                  <Box
                    component={"div"}
                    onClick={onClickNotesIssueMobaya}
                    className="dropdown-item"
                  >
                    <IconButton
                      className="icon"
                      sx={{
                        bgcolor:
                          item?.mobaya_reference === null && parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2) && item?.vcc?.shipping?.shipping_paid >= item?.vcc?.shipping?.shipping_total || parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2)
                            ? Colors.grey
                            : Colors.primary,
                        "&:hover": {
                          bgcolor:
                            item?.mobaya_reference === null && parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2) && item?.vcc?.shipping?.shipping_paid >= item?.vcc?.shipping?.shipping_total || parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2)
                              ? Colors.grey
                              : Colors.primary,
                        },
                      }}
                      disabled={item?.mobaya_reference === null && parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2) && item?.vcc?.shipping?.shipping_paid >= item?.vcc?.shipping?.shipping_total || parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2)}
                    >
                      <Edit
                        sx={{
                          color: Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      sx={{
                        color: item?.mobaya_reference === null && parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2) && item?.vcc?.shipping?.shipping_paid >= item?.vcc?.shipping?.shipping_total || parseFloat(parseFloat(item?.vcc?.custom_paid * 3.675) + parseFloat(item?.vcc?.vat_paid * 3.675)).toFixed(2) != parseFloat(parseFloat(item?.vcc?.custom_charges_aed) + parseFloat(item?.vcc?.vat_charges_aed)).toFixed(2) ? Colors.grey : Colors.black,
                      }}
                    >
                      Issue Credit Note
                    </Typography>
                  </Box>
                </Tooltip>
              )} */}

              {(permissions?.["delete-mobaya"] || user?.user_type == "A") && (
                <Tooltip
                  title={
                    parseFloat(item?.vcc?.custom_paid) > 0 &&
                    parseFloat(item?.vcc?.vat_paid) > 0
                      ? "Invoice is already paid."
                      : ""
                  }
                  arrow
                  placement="top"
                >
                  <Box
                    component={"div"}
                    onClick={onClickDeleteIssueMobaya}
                    className="dropdown-item"
                  >
                    <IconButton
                      sx={{
                        bgcolor:
                          parseFloat(item?.vcc?.custom_paid) > 0 &&
                          parseFloat(item?.vcc?.vat_paid) > 0
                            ? Colors.grey
                            : Colors.danger,
                        "&:hover": {
                          bgcolor:
                            parseFloat(item?.vcc?.custom_paid) > 0 &&
                            parseFloat(item?.vcc?.vat_paid) > 0
                              ? Colors.grey
                              : Colors.danger,
                        },
                      }}
                      disabled={
                        parseFloat(item?.vcc?.custom_paid) > 0 &&
                        parseFloat(item?.vcc?.vat_paid) > 0
                      }
                    >
                      <Delete
                        sx={{
                          color:
                            parseFloat(item?.vcc?.custom_paid) > 0 &&
                            parseFloat(item?.vcc?.vat_paid) > 0
                              ? Colors.grey
                              : Colors.white,
                          height: "16px !important",
                        }}
                      />
                    </IconButton>
                    <Typography
                      sx={{
                        color:
                          parseFloat(item?.vcc?.custom_paid) > 0 &&
                          parseFloat(item?.vcc?.vat_paid) > 0
                            ? Colors.grey
                            : Colors.danger,
                      }}
                    >
                      Delete
                    </Typography>
                  </Box>
                </Tooltip>
              )}
            </>
          )}

          {uploadVendorInvoiceEdit && (
            <div
              onClick={() => uploadVendorInvoiceEdit()}
              className="dropdown-item"
            >
              <IconButton sx={{}} className="icon">
                <Edit
                  sx={{
                    color: Colors.black,
                    height: "20px !important",
                  }}
                />
              </IconButton>
              <span>Edit </span>
            </div>
          )}

          {downloadVendorInvoice && (
            <div
              onClick={() => {
                downloadVendorInvoice();
              }}
              className="dropdown-item"
            >
              <Box
                sx={{
                  cursor: "pointer",
                  p: "8px",
                }}
                className="icon"
              >
                <FiDownload
                  sx={{
                    height: "16px !important",
                  }}
                  color={Colors.black}
                />
              </Box>
              <span>Download</span>
            </div>
          )}
        </div>
      )}

      <style jsx>{`
        .dropdown-container {
          position: relative;
          display: inline-block;
        }

        .dropdown-button {
          background-color: ${Colors.primary};
          border: none;
          cursor: pointer;
          color: ${Colors.white};
          border-radius: 100px;
          height: 30px;
          width: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .dropdown-menu {
          display: flex;
          flex-direction: column;
          position: absolute;
          align-items: flex-start;
          top: 100%;
          right: 0;
          background-color: #fff;
          border: 2px solid ${Colors.primary};
          border-radius: 5px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          z-index: 1000;
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          justify-content: flex-start !important;
          text-align: left;
          padding: 8px 16px;
          cursor: pointer;
          gap: 8px;
          width: 100%;
        }
        .dropdown-item:hover {
          background-color: #eff9e8;
        }

        .dropdown-item.disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .icon {
          margin-right: 8px;
        }
      `}</style>
    </div>
  );
};

export default DropdownMenu;
